<template>
  <div>
    <RouterView name="PageHeaderBar" />
    <div class="content-wrap">
      <div class="container-fluid">
        <div id="plugin-area" class="nav-wrapper">
          <nav id="side-nav" class="page-nav" :class="{ closed: sideNavClosed }">
            <LeftNavToolbar :class="{ closed: sideNavClosed }" @toggle="toggleSideNav">
              <template #return-link>
                <router-link class="nav-link no-scroll" title="Return to previous page" aria-label="A control that returns to the previous page" :to="{ name: 'internal-dashboards-root' }">
                  <font-awesome-icon :icon="['fas', 'arrow-left']" fixed-width />
                  <span class="sr-only">
                    Return to previous page
                  </span>
                </router-link>
              </template>
            </LeftNavToolbar>
            <MatchNav @toggle="toggleSideNav" />
          </nav>
          <div class="page-content">
            <RouterView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import MatchNav from "@/src/components/buckeye-coordinator-area/side_nav/MatchNav.vue";
import LeftNavToolbar from "@/src/components/shared/LeftNavToolbar.vue";

export default {
  components: {
    LeftNavToolbar,
    MatchNav
  },
  data() {
    return {
      sideNavClosed: false
    }
  },
  methods: {
    toggleSideNav() {
      this.sideNavClosed = !this.sideNavClosed;
    }
  }
}
</script>
